import { WFile } from './../types/file';
import { Log } from './../types/logBook';
import { CommonStateEnum } from "../types/common";
import { LogBook } from "../types/logBook";
import { Org } from "../types/org";
import { Product, ProductCategory } from "../types/product";
import { User } from "../types/user";
import { isCategory, isDoc, isLog, isOrg } from "./checkTool";
import { Doc } from '../types/doc';
import { ScanOrder } from '../types/scan';
import { CountingItem, CountingOrder, His, Inventory, Order } from '@/types/inventory';
import { App } from '../types/app';
import { Customer, Price, PriceHis, SaleOrder } from '@/types/sales';

export function cleanToUser(user: User): User {
  return {
    ...user,
    name1: user?.name1 ?? '',
    name2: user?.name2 ?? '',
    avatar: user?.avatar ?? '',
    logBookId: user?.logBookId ?? '',
    orgs: user?.orgs ?? [],
    permissions: user?.permissions ?? [],
    settings: user?.settings ?? [],
    state: user?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToOrg(org: Org): Org {
  return {
    ...org,
    path: org?.path ?? '',
    name: org?.name ?? '',
    avatar: org?.avatar ?? '',
    logBookId: org?.logBookId ?? '',
    subs: org?.subs?.filter(sub => isOrg(sub))?.map(sub => cleanToOrg(sub)) ?? [],
    state: org?.state ?? CommonStateEnum.ACTIVE,
    users: org.users ?? [],
    pId: org.pId ?? ''
  }
}

export function cleanToCategory(category: ProductCategory): ProductCategory {
  return {
    ...category,
    path: category?.path ?? '',
    name: category?.name ?? '',
    code: category?.code ?? '',
    subs: category?.subs?.filter(sub => isCategory(sub))?.map(sub => cleanToCategory(sub)) ?? [],
    state: category?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToProduct(product: Product): Product {
  return {
    ...product,
    model: product?.model ?? '',
    name: product?.name ?? '',
    code: product?.code ?? '',
    uom: product?.uom ?? '',
    state: product?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToLogBook(logBook: LogBook): LogBook {
  return {
    ...logBook,
    name: logBook?.name ?? ''
  }
}

export function cleanToLog(log: Log): Log {
  return {
    ...log,
    content: log?.content ?? '',
    docId: log?.docId ?? '',
    doc: log?.doc ?? null,
    subs: log?.subs?.filter(sub => isLog(sub))?.map(sub => cleanToLog(sub)) ?? [],
  }
}

export function cleanToDoc(doc: Doc): Doc {
  return {
    ...doc,
    path: doc?.path ?? '',
    name: doc?.name ?? '',
    suffix: doc?.suffix ?? '',
    fileId: doc?.fileId ?? '',
    subs: doc?.subs?.filter(sub => isDoc(sub))?.map(sub => cleanToDoc(sub)) ?? [],
    state: doc?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToScan(scan: ScanOrder): ScanOrder {
  return {
    ...scan,
    items: scan?.items ?? [],
    docId: scan?.docId ?? '',
    state: scan?.state ?? CommonStateEnum.ACTIVE,
  }
}

export const cleanToFile = (file: WFile): WFile => {
  return {
    ...file,
    name: file?.name ?? '',
    suffix: file?.suffix ?? '',
    size: file?.size ?? 999,
    mime: file?.mime ?? '',
  }
}
export function cleanToInventory(inventory: Inventory): Inventory {
  return {
    ...inventory,
    his: inventory?.his ?? [],
    barcodes: inventory?.barcodes ?? [],
    state: inventory?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToHis(inventoryHis: His): His {
  return {
    ...inventoryHis,
    inventoryOrder: inventoryHis?.inventoryOrder ?? '',
    inventoryOrderItem: inventoryHis?.inventoryOrderItem ?? '',
    state: inventoryHis?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToOrder(order: Order): Order {
  return {
    ...order,
    sourceId: order?.sourceId ?? '',
    items: order?.items ?? [],
    scans: order?.scans ?? [],
    state: order?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToCountingOrder(countingOrder: CountingOrder): CountingOrder {
  return {
    ...countingOrder,
    items: countingOrder?.items ?? [],
    scans: countingOrder?.scans ?? [],
    state: countingOrder?.state ?? CommonStateEnum.ACTIVE,
  }
}

export function cleanToCountingItem(countingItem: CountingItem): CountingItem {
  return {
    ...countingItem,
    counting: countingItem?.counting ?? '',
    stock: countingItem?.stock ?? '',
    countingBarcodes: countingItem?.countingBarcodes ?? [],
    stockBarcodes: countingItem?.stockBarcodes ?? [],
  }
}

export function cleanToApp(app: App): App {
  return {
    ...app
  }
}

export function cleanToCustomer(customer: Customer): Customer {
  return {
    ...customer,
  }
}

export function cleanToPrice(price: Price): Price {
  return {
    ...price,
  }
}

export function cleanToPriceHis(price: PriceHis): PriceHis {
  return {
    ...price,
  }
}

export function cleanToSaleOrder(info: SaleOrder): SaleOrder {

  return {
    ...info,
  }
}
